export default {
	"1bfe098ef779f3115e373f10dd8734cd": "There are already more favorable orders for this product, with the amount to be paid",
	"28b8eb041fa23be520e7d2e47b5bf270": "yuan",
	"2a7871065fc3ff143f5f895dd21fc06e": "Go and check"
}
